import {useCallback, useEffect, useState} from 'react';

// The server's clock minus this device's, the NTP way: a burst of round trips, keeping the fastest. A fast trip
// can't be very lopsided, so its error is at most half its length (5–20 ms on venue wifi), where a single slow or
// lopsided trip could be off by 100+.
const SAMPLES = 8;

const sample = async () => {
    const sent = performance.now();
    const response = await fetch('/time', {cache: 'no-store'});
    const {time} = await response.json();
    const rtt = performance.now() - sent;
    // performance.now measures the trip; Date.now places it on the wall clock the server's time is compared with
    return {rtt, drift: parseInt(time, 10) + rtt / 2 - Date.now()};
};

const measure = async () => {
    let best = null;
    for (let i = 0; i < SAMPLES; i++) {
        try {
            const s = await sample();
            if (!best || s.rtt < best.rtt) best = s;
        } catch (e) {}
    }
    if (best) console.log(`Clock drift: ${Math.round(best.drift)} ms (±${Math.round(best.rtt / 2)} ms)`);
    return best;
};

export const useClockDrift = (syncInterval = 60000) => {
    const [clockDrift, setClockDrift] = useState(0);

    const sync = useCallback(async () => {
        const best = await measure();
        if (best) setClockDrift(Math.round(best.drift));
    }, []);

    useEffect(() => {
        const first = setTimeout(sync, 1000);
        const intervalId = setInterval(sync, syncInterval);
        return () => { clearTimeout(first); clearInterval(intervalId); };
    }, [sync, syncInterval]);

    useEffect(() => {
        const onVisibilityChange = () => {
            if (document.hidden) return;
            setTimeout(sync, 1000);
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => document.removeEventListener('visibilitychange', onVisibilityChange);
    }, [sync]);

    return clockDrift;
};
